import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { MessageResponse } from '@ujet/websdk-headless';
import { ProductCard } from './components/ProductCard';
import styles from './ProductCards.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const CN = 'product-cards';

export interface ProductInfo {
  body: string;
  product_ID: string | undefined;
  variantId: number | undefined;
  link: string;
  subtitle: string;
  title: string;
  price: string | undefined;
  imageUrl: string | undefined;
}

interface ProductCardsProps {
  message: MessageResponse;
  scrollToBottom: () => void;
}

const EMPTY_CARD_PREFIX = '$playbook.input.product_cards';

export const ProductCards = ({ message, scrollToBottom }: ProductCardsProps): React.ReactElement => {
  const cards = useMemo(() => (message.cards as ProductInfo[]).filter(
    card => !card.title.startsWith(EMPTY_CARD_PREFIX)
  ), [ message.cards ]);

  return (
    <Box className={ cx(CN) }>
      {cards.map((card, index) => <ProductCard key={ index } cardContent={ card } scrollToBottom={ scrollToBottom } />)}
    </Box>
  );
};
